import { useEffect, useRef } from "react";

export function useRecarregarAoAtivar(ativa: boolean, recarregar: () => void) {
  const estavaAtiva = useRef(ativa);

  useEffect(() => {
    if (ativa && !estavaAtiva.current) recarregar();
    estavaAtiva.current = ativa;
  }, [ativa, recarregar]);
}
